const COLOR = {
  whitePrimary: "#FAFAFA",
  goldPrimary:
    "linear-gradient(131.9deg, #8A4026 -10.92%, #966D32 -9.61%, #A78041 -7%, #BA9653 -5.69%, #D8B870 -0.46%, #E4C67B 0.85%, #DBB565 4.77%, #D9B160 6.08%, #D2A550 10%, #D0A14B 12.62%, #D5A750 16.54%, #DDB258 20.46%, #E4BD61 24.39%, #F4D576 29.62%, #F8E881 37.46%, #F2DF7B 41.39%, #E7C969 47.93%, #E3C263 51.85%, #F0D35A 59.69%, #F9DF58 64.92%, #EFD052 70.16%, #DBB640 79.31%, #D2AA38 85.85%, #C69930 92.39%, #C1932D 98.92%, #C59833 100.23%, #D2A744 104.15%, #EAC565 106.77%, #DCB755 110.69%, #D5AF4C 113.31%, #CBA542 115.92%)",
  primary10: "#A98137",
  primary20: "#FFF9EB",
  primary50: "#FAF7F0",
  primary100: "#F5EEE0",
  primary200: "#EBDCC1",
  primary300: "#E1CBA3",
  primary400: "#E8AC3D",
  primary500: "#CCA763",
  primary600: "#C8A056",
  primary700: "#C39746",
  primary800: "#5C400C",
  primary900: "#70531F",
  bg: "#ecddc4",
  borderBg: "#cca763",
  accent50: "#FBEFEE",
  accent100: "#F0BEBC",
  accent200: "#E89E9B",
  accent300: "#DD6D69",
  accent400: "#D54D48",
  accent500: "#B12C28",
  accent600: "#A62A26",
  accent700: "#962622",
  accent800: "#85221E",
  accent900: "#641917",
  gray: "gray",
  gray10: "#393939",
  gray50: "#F5F5F5",
  gray100: "#E0E0E0",
  gray200: "#CCCCCC",
  gray300: "#B8B8B8",
  gray400: "#A3A3A3",
  gray500: "#8F8F8F",
  gray600: "#7A7A7A",
  gray700: "#666666",
  gray800: "#474747",
  gray900: "#1A1A1A",
  green700: "#0D6F34",
  blue: "#0068FF",
};

export default COLOR;
